<template>
  <div v-if="jobList.length" class="zip-export-progress">
    <div v-for="job in jobList" :key="job.id" class="zep-card" :class="`zep-card--${job.status}`">
      <div class="zep-head">
        <span class="zep-icon">
          <a-spin v-if="job.status === 'running'" size="small" />
          <span v-else-if="job.status === 'done'" class="zep-ok">✓</span>
          <span v-else class="zep-err">!</span>
        </span>
        <span class="zep-name" :title="job.name">{{ job.name }}</span>
        <button
          v-if="job.status !== 'running'"
          class="zep-close"
          title="Fermer"
          @click="dismiss(job.id)"
        >×</button>
      </div>
      <div class="zep-stage">{{ job.stage }}</div>
      <div v-if="job.status === 'running'" class="zep-bar">
        <div
          class="zep-bar-fill"
          :class="{ 'zep-bar-fill--indeterminate': job.total === 0 }"
          :style="job.total > 0 ? { width: percent(job) + '%' } : undefined"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useZipExport, ZipExportJob } from '/@/hooks/use-zip-export'

const { jobs, dismiss } = useZipExport()

const jobList = computed(() => Object.values(jobs))

function percent (job: ZipExportJob): number {
  if (job.total <= 0) return 0
  return Math.min(100, Math.round((job.current / job.total) * 100))
}
</script>

<style lang="scss" scoped>
.zip-export-progress {
  position: fixed;
  bottom: 16px;
  right: 16px;
  z-index: 3000;
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 260px;
  pointer-events: none;
}
.zep-card {
  pointer-events: auto;
  background: rgba(30, 30, 30, 0.96);
  border: 1px solid #3a3a3a;
  border-radius: 8px;
  padding: 10px 12px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.5);
  color: #ddd;
  &--done { border-color: #52c41a; }
  &--error { border-color: #ff4d4f; }
}
.zep-head {
  display: flex;
  align-items: center;
  gap: 8px;
}
.zep-icon {
  display: inline-flex;
  width: 18px;
  justify-content: center;
  flex-shrink: 0;
}
.zep-ok { color: #52c41a; font-weight: 700; }
.zep-err {
  color: #ff4d4f;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border: 1px solid #ff4d4f;
  border-radius: 50%;
  font-size: 11px;
}
.zep-name {
  flex: 1;
  font-size: 13px;
  font-weight: 600;
  color: #fff;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.zep-close {
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  border: none;
  background: transparent;
  color: #999;
  font-size: 16px;
  line-height: 1;
  cursor: pointer;
  padding: 0;
  &:hover { color: #fff; }
}
.zep-stage {
  margin-top: 4px;
  font-size: 11px;
  color: #aaa;
}
.zep-bar {
  margin-top: 8px;
  height: 4px;
  border-radius: 2px;
  background: #444;
  overflow: hidden;
}
.zep-bar-fill {
  height: 100%;
  background: #1677ff;
  border-radius: 2px;
  transition: width 0.2s ease;
}
.zep-bar-fill--indeterminate {
  width: 40%;
  animation: zep-indet 1.1s ease-in-out infinite;
}
@keyframes zep-indet {
  0% { margin-left: -40%; }
  100% { margin-left: 100%; }
}
</style>
